import type { Trip } from "@/types/api";

export function formatTripLabel(trip: Trip): string {
  return trip.tripNumber != null
    ? `Trip #${trip.tripNumber}`
    : (trip.name ?? "Trip number unavailable");
}
